<template>
  <div>
    <div class="header">
      <div class="overlay">
        <div class="section">
          <div class="container mb-0 mt-0">
            <div class="row">
              <div class="col-7">
                <a href="/">
                  <div class="logo-wrapper">
                    <div class="codelos-logo">
                      <img src="https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/pics/logo.svg"/>
                    </div>
                    <div class="title">
                      &nbsp;&nbsp;Codelos.io
                      <span class="subcategory">Lastprofile-Generator</span>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col">
                <div class="nav custom">
                  <ul>
                    <li v-if="!isMobile" class="list-item">
                      <a
                        class="btn-red"
                        href="https://www.slp-generator.app.codelos.io/"
                      >
                        <span v-show="!isAuthenticated">Login</span>
                        <span v-show="isAuthenticated">Profil</span>
                      </a>
                    </li>
                    <li v-if="isMobile" class="list-item">
                      <a href="#/profile">Login</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row intro">
              <div class="col">
                <div class="">
                  <h1>Lastprofile-Generator</h1>
                  <p>
                    Erstellen Sie repräsentative Strom Lastprofile für Haushalte, Landwirtschaft und Gewerben.
                  </p>
                  <a class="btn-red" href="#/subscribe"
                    >Zugangsdaten anfordern</a
                  >
                </div>
              </div>
              <div v-if="!isMobile" class="col-md-8">
                <div class="video-wrapper">
                  <video
                    :poster="getPosterUrl(video1)"
                    playsinline="playsinline"
                    autoplay="autoplay"
                    muted="muted"
                    loop="loop"
                    ref="videoElement1"
                    :src="getVideoUrl(video1)"
                    type="video/mp4"
                  ></video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isMobile" class="section shape">
      <svg
        class="index-header-wave"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 288"
      >
        <defs></defs>
        <path
          fill="#F6FAFC"
          fill-rule="evenodd"
          d="M0,1091 C92.6666667,1149.66667 202,1179 328,1179 C517,1179 563,1146 720,1091 C877,1036 959,987 1106,987 C1204,987 1315.33333,1021.66667 1440,1091 L1440,1275 L0,1275 L0,1091 Z"
          transform="translate(0 -987)"
        ></path>
      </svg>
    </div>
    <div class="section gray-background">
      <div class="container text-dark mt-0">
        <div class="row intro my-5">
          <div class="col-md-8" align="left">
            <img
              alt="Lastgang analysieren überprüfen und korrigieren"
              class="icon icon-lg"
              src="../assets/recognize.png"
            />
          </div>
          <div class="col">
            <div>
              <h3>Vordefinierte Kundengruppen</h3>
              <p>
                Durch Standardlastprofile (SLP) für unterschiedliche
                Kundengruppen kann auch ohne eigene Lastgangdaten eine Prognose
                für den individuellen Energieverbrauch erstellt werden.
              </p>
            </div>
          </div>
        </div>
        <div class="row intro my-5">
          <div v-if="isMobile" class="col-md-8" align="left">
            <img
              alt="Lastgang analysieren überprüfen und korrigieren"
              class="icon icon-lg"
              src="../assets/correct.png"
            />
          </div>
          <div class="col">
            <div>
              <h3>Anpassbare Profile</h3>
              <p>
                Die Lastprofile können individuell angepasst werden. Sowohl unterschiede in Gesmatverbrauch als auch regionale
                Unterschiede können im Verbrauch berücksichtigt werden, sodass auf dieser Basis
                zuverlässige Prognosen erstellt werden können.
              </p>
            </div>
          </div>
          <div v-if="!isMobile" class="col-md-8" align="right">
            <img
              alt="Lastgang analysieren überprüfen und korrigieren"
              class="icon icon-lg"
              src="../assets/correct.png"
            />
          </div>
        </div>
        <div class="row intro my-5">
          <div class="col-md-8" align="left">
            <img
              alt="Lastgang analysieren überprüfen und korrigieren"
              class="icon icon-lg"
              src="../assets/transform.png"
            />
          </div>
          <div class="col">
            <h3>Verschiedene Exportmöglichkeiten</h3>
            <p>
             Exportieren Sie Ihre Daten in ein beliebiges Format,
              teilen Sie die Zeitreihen direkt aus der Plattform mit Ihren Kollegen per E-Mail oder 
              fragen Sie die Daten direkt aus Ihren Systemen per API.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="section dark-background">
      <div class="container">
        <div class="row">
          <div class="col-md">
            <h2>Die einfach zu bedienende API</h2>
            <p>
              Integrieren Sie die Plattform in Ihrer Systemlandschaft in Minuten und bringen Sie einen Mehrwert zu Ihrer Anwendungen.
            </p>
            <p>
              <a href="https://developer.codelos.io"
                >Developer Bereich<i class="fas fa-caret-right ml-3 my-3"></i
              ></a>
            </p>
          </div>
          <div class="col-md-7">
            <div class="video-wrapper">
              <video
                ref="video3"
                class="video-example"
                loop="loop"
                autoplay="autoplay"
                playsinline
                preload="none"
                muted="muted"
                alt="Py Loadparser example"
                poster="../assets/coding-demo.png"
                v-playback-rate="1"
              >
                <source
                  src="https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/videos/coding-demo2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section purple-background">
      <div class="container">
        <div class="row">
          <div class="col">
            <h2>
              prognoziren Sie effizienter und 
              optimieren Sie Ihre Systeme durch kundenspezifische Lastprofile.
            </h2>
            <a class="btn-white" href="#/subscribe">
              Fordern Sie Ihre Zugangsdaten an
            </a>
          </div>
        </div>
      </div>
    </div>
    <section>
      <ul class="inline-list">
        <li>
          <a href="#/impressum">Impressum</a>
        </li>
        <li>
          <a href="#/privacy">Datenschutzerklärung</a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script scoped>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
//import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
export default {
  name: "Home",
  data() {
    return {
      videoElement: null,
      dropdown1: true,
      video1: "demo1.mp4",
      video2: "demo4.mp4",
      s3EndPoint:
        "https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/videos/",
    };
  },
  methods: {
    getVideoUrl: function (video) {
      //var videos = require.context("../assets/", false, /\.mp4$/);
      //return videos(video);
      return this.s3EndPoint + video;
    },
    getPosterUrl: function (video) {
      var images = require.context("../assets/", false, /\.jpg$/);
      return images("./" + video.replace(".mp4", "-poster.jpg"));
    },
    playVideo: function (video, target) {
      this[target] = video;
      var div = video.replace(".mp4", "-" + target + "-col").replace("./", "");
      var els = this.$el.querySelectorAll(".clickable");
      els.forEach((e) => {
        e.classList.remove("active");
      });
      this.$refs[div].classList.add("active");
    },
  },
  mounted() {
    //this.videoElement.play()
    //document.getElementsByClassName("video-example")[0].playbackRate = 8.5;
  },
  computed: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    isAuthenticated() {
      var bln =
        localStorage.getItem("amplify-signin-with-hostedUI") === "false";
      return bln;
    },
  },
  components: {},
};
</script>

<style>
@import "https://use.fontawesome.com/releases/v5.6.3/css/all.css";
@import "https://fonts.googleapis.com/css?family=Hammersmith+One|Nunito|Orbitron:500|Poiret+One";

*,
*::before,
*::after {
  box-sizing: unset;
}

html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeSpeed;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.header ul.dropdown li {
  display: list-item;
  background: rgb(12, 13, 17, 0.75);
  padding: 16px 25px 1px;
}

.dropdown {
  position: absolute;
  background-color: black;
  display: block;
  margin-top: 10px;
}

.arrow-bottom {
  transform: rotate(90deg) scaleY(2);
  display: inline-block;
  line-height: 7px;
  font-size: 13px;
  font-weight: 800;
  margin-left: 8px;
}

a {
  cursor: pointer;
  color: inherit;
}

a:hover {
  color: inherit;
}

.inline-list {
  list-style: unset;
}

.inline-list li {
  display: inline-block;
  margin-right: 15px;
}

.inline-list li a:hover {
  text-decoration: underline;
}

a.btn-white:hover {
  color: rgb(255, 51, 102);
}

a.btn-white {
  cursor: pointer;
  display: inline-block;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  color: rgb(23, 25, 29);
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.12) 0px 20px 40px 0px;
  text-decoration: none;
  border-radius: 999em;
  transition: color 200ms ease-in-out 0s, background-color, box-shadow,
    transform, fill;
  padding: 15.25px 32px;
  border: none;
  margin-bottom: 32px;
  margin-top: 16px;
  font-weight: 700;
}

.section-pic {
  width: 600px;
}

.pink-background {
  background-color: rgb(255, 51, 102);
  color: #fff;
}

.purple-background {
  background-color: #794cff;
  color: #fff;
}

.dark-background {
  background-color: rgb(54 72 89);
  color: #fff;
}

.section.dark-background h2 {
  color: #fff;
}

.section.pink-background h2 {
  color: #fff;
}

.section.purple-background h2 {
  color: #fff;
}

.section.shape {
  margin-top: -324px;
  padding: 0;
  width: 100%;
  /*max-height: 324px;*/
}

.column {
  /*margin-bottom: 75px;
  margin-top: 75px;*/
  padding-right: 0px;
  padding-left: 0px;
}

.column .column-content {
  padding: 30px;
  max-width: 100%;
}

.icon-wrapper {
  text-align: left;
  padding: 29px 0;
  height: 58px;
}

.icon {
  height: 57px;
}

.icon.medium {
  height: 51px;
}

.icon.small {
  height: 44px;
}

.text-dark {
  color: rgb(23, 25, 29);
}

.column h3 {
  font-size: 24px;
  font-size: 24px;
  letter-spacing: 0px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.3;
  font-weight: 500;
  color: rgb(23, 25, 29);
  margin: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeSpeed;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeSpeed;
  padding-bottom: calc(var(--cel, 2.5vw) * 0.5);
  cursor: pointer;
  text-align: left;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  letter-spacing: 0px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.3;
  font-weight: 500;
  color: rgb(23, 25, 29);
  margin: 0px;
}

.container .column p {
  font-size: 18px;
  letter-spacing: 0.12px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.5;
  font-weight: 400;
  color: rgb(23, 25, 29);
  margin: 0px;
  text-align: left;
}

.section {
  display: block;
  display: flex;
}

.section h2 {
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.08;
  font-weight: 500;
  color: rgb(23, 25, 29);
  margin: 0px 0px 0px;
}

.overlay {
  width: 100%;
  margin-top: 0;
  top: 0;
  height: 99%;
}

.header-background-video {
  width: 100%;
  margin: -15px;
  overflow: hidden;
}

.vue-video-section__video-element {
  width: 100%;
  margin: -15px;
}

.btn-wrapper {
  text-align: center;
}

.container p {
  font-size: calc(18px + (4 * (100vw - 800px)) / 800);
  letter-spacing: 0px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.3;
  font-weight: 400;
  margin: 0px;
}

.header .container p {
  font-size: calc(18px + (4 * (100vw - 800px)) / 800);
  letter-spacing: 0px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.3;
  font-weight: 400;
  margin: 0px;
}

.container {
  margin: 57px auto;
}

.intro {
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
}

.container h1 {
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 1rem;
}

.intro h1 {
  font-size: 50px;
}

.content {
  text-align: center;
}

.container .btn-wrapper .btn-red {
  padding: calc(40px + (8 * (100vw - 800px)) / 800);
  padding-bottom: calc(18px + (4 * (100vw - 800px)) / 800);
  padding-top: calc(18px + (4 * (100vw - 800px)) / 800);
  cursor: pointer;
  display: inline-block;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  color: rgb(255, 255, 255);
  background-color: rgb(255, 51, 102);
  box-shadow: rgba(0, 0, 0, 0.12) 0px 20px 40px 0px;
  text-decoration: none;
  border-radius: 999em;
  transition: color 200ms ease-in-out 0s, background-color, box-shadow,
    transform, fill;

  letter-spacing: 0px;
  font-family: "Aktiv Grotesk", -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.12;
  font-weight: 700;
  color: inherit;
  text-align: center;
  margin: 0px;
}

.btn-red {
  cursor: pointer;
  display: inline-block;
  position: relative;
  user-select: none;
  vertical-align: middle;
  color: rgb(255, 255, 255);
  background-color: rgb(255, 51, 102);
  box-shadow: rgba(0, 0, 0, 0.12) 0px 20px 40px 0px;
  text-decoration: none;
  border-radius: 999em;
  transition: color 200ms ease-in-out 0s, background-color, box-shadow,
    transform, fill;
  padding: 5.5px 21px;
  line-height: 29px;
  margin-top: 35px;
}

.nav.custom .btn-red {
  padding: 6px 35px;
  margin-top: -2px;
}

.subcategory {
  font-size: 20px;
  border-left: solid 1px;
  margin-left: 15px;
  padding-left: 16px;
  padding-top: 3px;
  vertical-align: middle;
}

.header {
  display: block;
  width: 100%;
  min-height: 606px;
  max-height: 800px;
  top: 0;
  overflow: hidden;
}

.logo-wrapper {
  padding-top: 29px;
  height: 33px;
  padding-bottom: 36px;
  display: inline-block;
  box-sizing: border-box;
}

.header .codelos-logo {
  float: left;
  width: 45px;
  margin-top: -10px;
  padding: 0px 20px 5px 0px;
}

.header .codelos-logo img {
  width: 70px;
}

.header .section {
  margin-top: 0px;
}

.title {
  float: left;
  margin: 6px 20px 0px 10px;
  padding-right: 23px;
  line-height: 33px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  font-family: "Nunito", sans-serif;
}

.header ul li {
  list-style: none;
  display: inline;
  font-family: "Open Sans", open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;

  cursor: pointer;
}

.header ul {
  padding: 0;
  margin: 0;
  height: 33px;
}

.header ul li a {
  text-decoration: none;
  display: block;
  height: 31px;
}

.header ul li a.active {
  padding: 0;
  margin: 0;
  margin-left: 75px;
  display: block;
  height: 29px;
}

.header ul li a:hover {
  color: #ffff;
}

.header ul li a:visited {
  text-decoration: none;
}

.header .list-item {
  display: inline-block;
}

.header .menu2-bar .list-item {
  margin: 0 75px 0 0;
  vertical-align: top;
}

.header .menu2-bar .list-item.active {
  margin: 0 75px 0 0;
  border-bottom: solid 2px rgb(255, 51, 102);
}

.header .Button__button___1FrBC {
  /*float: right;*/
  background: none;
  border: none;
  text-transform: none;
  color: #9aa4b3;
  display: inline;
  font-family: "Open Sans", open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  color: #9aa4b3;
  cursor: pointer;
  padding: none;
}

.toggle-list-wrapper .item.more:hover {
  background-color: #fff;
}

.header ul li a.more:hover {
  background-position: -62px 3px;
}
a.sign-out {
  position: absolute;
  right: 20px;
  top: -24px;
}
.toggle-list-wrapper {
  background-color: #ffff;
  position: relative;
  left: -53px;
  top: 36px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 2;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toggle-list-wrapper .item {
  cursor: pointer;
  padding: 9px 23px;
  text-align: left;
  height: fit-content;
  margin: 0;
  font-weight: 300;
  color: #464d5d;
  font-size: 11px;
}
.toggle-list-wrapper .item.last-item {
  border-top: solid 1px #e1e4ea;
}

.toggle-list-wrapper .item:hover {
  background-color: #f0f0f0;
}

.playsinline {
  height: 100%;
}

video {
  min-width: 100%;
  max-width: 100%;
  width: 100%;
  border-radius: 5px;
  /*box-shadow: rgb(0 0 0 / 5%) 0px 10px 20px, rgb(0 0 0 / 20%) 0px 0px 1px;*/
  box-shadow: rgb(0 0 0 / 7%) 0px 1px 10px, rgb(0 0 0 / 2%) 0px 2.4px 5.7px,
    rgb(0 0 0 / 2%) 0px 4px 11.3px, rgb(0 0 0 / 2%) 0px 10.6px 17.5px,
    rgb(0 0 0 / 3%) 0px 14px 25.7px, rgb(0 0 0 / 4%) 0px 35.5px 39.6px,
    rgb(0 0 0 / 3%) 0px 40px 48px;
}

.no-padding-top {
  padding-top: 0;
}

.clickable {
  cursor: grab;
}

/*.column.col-md-4*/
.clickable.active .column-content .line-top {
  border-top: 3px solid rgb(255, 51, 102);
}

.clickable .column-content .line-top {
  border-top: 3px solid rgb(222, 224, 227);
}

.clickable.active {
  transform: translate(0px, -22px);
  transition: transform 0.33s cubic-bezier(0, 0, 0.58, 1) 0s;
}

.clickable:hover {
  transform: translate(0px, -22px);
  transition: transform 0.33s cubic-bezier(0, 0, 0.58, 1) 0s;
}

.margin-md {
  margin-top: 70px;
  margin-bottom: 70px;
}

.no-box-shadow {
  box-shadow: none;
}

.section .container.no-margin-bottom {
  /*margin-bottom: 0px;*/
}

.icon-lg {
  height: 390px;
  margin-top: 0;
  /*box-shadow: 0 2px 6px -1px rgb(0 0 0 / 16%), 0 1px 4px -1px rgb(0 0 0 / 4%);
  box-shadow: 0 0 8px -2px rgb(0 0 0 / 10%), 0 6px 20px -3px rgb(0 0 0 / 20%);*/
}

.round-gray-background {
  background: #faf9fa;
  border-radius: 50%;
  height: 190px;
  width: 190px;
}

.icon-column {
}

.margin-top-bottom-md {
  margin-top: 100px;
  margin-bottom: 100px;
}

.margin-top-md {
  margin-top: 100px;
}

/*API-Section*/
.api-title {
  text-shadow: -2px 2px 3px #9a9a9ae8;
}

.api-subtitle {
  margin-left: 15%;
  font-size: 2.3rem;
}

.video-example {
  box-shadow: 3px 3px 20px 1px #464646;
}

/* 
small screens 
*/
@media (max-width: 414px) {
  .header {
    min-height: 400px;
  }

  .header .intro {
    padding-top: 110px;
    padding-bottom: 110px;
  }

  .no-mobile-device {
    height: 0;
    width: 0;
    visibility: hidden;
  }

  .logo-wrapper {
    margin-left: 0;
    padding-top: 0;
  }

  .header .codelos-logo {
    float: left;
    line-height: 17px;
    width: 28px;
    padding: 5px 10px 5px 9px;
  }

  .custom {
    font-size: 21px;
    height: 38px;
    float: right;
    text-align: left;
    margin-right: 10%;
  }

  .free {
    display: none;
  }

  .header .list-item {
    font-size: calc(17px + (16 * (100vw - 400px)) / 400);
    margin: 0;
    text-decoration: underline;
  }

  .content h1 {
    margin-bottom: calc(var(--cel, 2.5vw) * 2);
    letter-spacing: calc(-0.5px + (-0.25 * (100vw - 400px)) / 400);
    font-size: calc(22.4px + (25.6 * (100vw - 175px)) / 201);
  }

  .title {
    font-size: calc(17px + (16 * (100vw - 400px)) / 400);
    margin: 0px 0px 0px 7px;
    padding-right: 0px;
  }

  .title .subcategory {
    font-size: calc(13px + (16 * (100vw - 400px)) / 400);
    margin-left: 7px;
    padding-left: 13px;
  }

  .container {
    margin: 55px auto;
  }

  .section.pink-background .container {
    /*padding-top: 78px;*/
  }

  .section.dark-background .container {
    /*padding-top: 78px;*/
  }

  .container .btn-red {
    z-index: 2;
    margin: 120px auto;
    margin-top: calc(var(--cel, 2.5vw) * 1.5);
    margin-bottom: calc(var(--cel, 2.5vw) * 1.5);
    font-size: calc(6.5px + (7.5 * (100vw - 175px)) / 201);
  }

  .round-gray-background {
    border-radius: 5px;
    height: 166px;
    width: 100%;
    margin-left: 0px;
  }

  .icon-lg {
    height: 211px;
    margin-top: 40px;
    margin-left: 0;
    margin-bottom: 40px;
  }

  .margin-top-bottom-md {
    margin-top: 22px;
    margin-bottom: 100px;
  }

  .no-box-shadow {
    margin-bottom: 10px;
  }

  video {
    max-height: 233px;
  }
}

/* 
medium screens 
*/
@media (min-width: 414px) {
  .logo-wrapper {
    margin-left: 0;
    padding-top: 0;
  }

  .custom {
    font-size: 21px;
    height: 77px;
    float: right;
    text-align: left;
    margin-bottom: 80px;
  }

  .header .list-item {
    margin: 0;
  }

  .word-separator {
    display: none;
  }

  .content h1 {
    margin-bottom: calc(var(--cel, 2.5vw) * 0.5);
    margin-top: calc(var(--cel, 2.5vw) * 1.3);
    letter-spacing: calc(-2.5px + (-0.5 * (100vw - 800px)) / 800);
    font-size: calc(96px + (16 * (100vw - 800px)) / 800);
  }

  .title {
    font-size: calc(30px + (2 * (100vw - 800px)) / 800);
  }

  .container {
    margin: 57px auto;
  }

  .section .container.no-margin-top-bottom {
    margin: 0px auto;
  }

  .section .container {
    margin: 40px auto 85px;
  }

  .section {
    padding-top: calc(var(--cel, 2.5vw) * 1.5);
    padding-bottom: calc(var(--cel, 2.5vw) * 1.5);
    box-sizing: unset;
  }

  .section h2 {
    margin-bottom: calc(var(--cel, 2.5vw) * 0.5);
    letter-spacing: -1px;
    font-size: calc(23px + (16 * (100vw - 400px)) / 400);
  }

  .container .btn-red {
    /*margin-top: calc(var(--cel, 2.5vw) * 2);*/
    font-size: calc(20px + (2 * (100vw - 800px)) / 800);
    padding: calc(40px + (8 * (100vw - 800px)) / 800);
    padding-bottom: calc(18px + (4 * (100vw - 800px)) / 800);
    padding-top: calc(18px + (4 * (100vw - 800px)) / 800);
  }
}

/* 
large screens 
*/
@media (min-width: 1024px) {
  .content h1 {
    margin-bottom: calc(var(--cel, 2.5vw) * 0.5);
    margin-top: calc(var(--cel, 2.5vw) * 1.3);
    letter-spacing: calc(-2.5px + (-0.5 * (100vw - 800px)) / 800);
    font-size: 104px;
  }

  .title {
    font-size: calc(30px + (2 * (100vw - 800px)) / 800);
  }

  .container {
    margin: 57px auto;
  }

  .section .container.no-margin-top-bottom {
    margin: 0px auto;
  }

  .section .container {
    margin: 40px auto 85px;
  }

  .section {
    padding-top: calc(var(--cel, 2.5vw) * 2);
  }

  .section.no-padding-top {
    padding-top: 0px;
  }

  .section h2 {
    margin-bottom: calc(var(--cel, 2.5vw) * 0.5);
    letter-spacing: -1px;
    font-size: 50px;
  }

  .container .btn-red {
    font-size: calc(20px + (2 * (100vw - 800px)) / 800);
    padding: calc(40px + (8 * (100vw - 800px)) / 800);
    padding-bottom: calc(11px + (4 * (100vw - 800px)) / 800);
    padding-top: calc(11px + (4 * (100vw - 800px)) / 800);
  }
}

.index-header-wave {
  z-index: -3;
}

.gray-background {
  background: #f6fafc;
}
</style>